import { EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../app/api.service';
var ComponentTool = (function () {
    function ComponentTool(route, apiService, router) {
        this.route = route;
        this.apiService = apiService;
        this.router = router;
        this.submitAt = ""; //顾问第一次回答的时间
        this.context = ""; //追问
        this.onShowToast = new EventEmitter();
        this.ongetStudentAppreciate = new EventEmitter();
        this.ongetMyAppreciate = new EventEmitter();
        this.data = {};
    }
    ComponentTool.prototype.ngOnInit = function () {
        var _this = this;
        var submitAt = null;
        submitAt = this.submitAt && typeof (this.submitAt) != "undefined" ? this.submitAt.split('.')[0].split('T') : "";
        this.submitAt = submitAt ? submitAt[0] + " " + submitAt[1] : "";
        this.route.queryParams.subscribe(function (queryParams) {
            _this.learningPathId = queryParams['learningPathId'];
            _this.courseId = queryParams['courseId'];
            _this.isLastDay = !!queryParams['isLastDay'];
            _this.isFirstDay = !!queryParams['firstDay'];
            _this.projectId = queryParams['projectId'];
            _this.courseLearningPathMetaId = queryParams['courseLearningPathMetaId'];
        });
    };
    ComponentTool.prototype.ngAfterViewInit = function () {
    };
    //点赞
    ComponentTool.prototype.favour = function () {
        var _this = this;
        if (this.tabNum == 0) {
            this.data.relationId = this.myData.relationId;
            this.data.type = "appreciate";
            this.getAppreciate().then(function (result) {
                if ((!!result.some(function (item) { return item.userCampExerciseQuestionGroupMetasRelationId === _this.myData.relationId; }) === false)) {
                    _this.giveAppreciate(_this.data).then(function (result) {
                        _this.ongetMyAppreciate.emit();
                    });
                }
                else {
                    _this.onShowToast.emit(true);
                }
            });
        }
        else if (this.tabNum == 1) {
            this.data.relationId = this.relationId;
            this.data.type = "appreciate";
            //判断是否已经点过赞
            this.getAppreciate().then(function (result) {
                //没点过
                if ((!!result.some(function (item) { return item.userCampExerciseQuestionGroupMetasRelationId === _this.relationId; }) === false)) {
                    _this.giveAppreciate(_this.data).then(function (result) {
                        _this.ongetStudentAppreciate.emit({ studentList: _this.studentList, relationId: _this.relationId });
                    });
                }
                else {
                    _this.onShowToast.emit(true);
                }
            });
        }
    };
    //评论
    ComponentTool.prototype.goComment = function () {
        if (this.isFirstDay) {
            this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId, 'constituteId': this.constituteId, 'tabNum': this.tabNum, type: "comment", comment: this.comment, learningPathId: this.learningPathId, courseId: this.courseId, firstDay: 1 } });
        }
        else if (this.isLastDay) {
            this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId, 'constituteId': this.constituteId, 'tabNum': this.tabNum, type: "comment", comment: this.comment, learningPathId: this.learningPathId, courseId: this.courseId, isLastDay: 1 } });
        }
        else {
            if (this.workSource == 'homework') {
                if (this.projectId) {
                    this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId, 'constituteId': this.constituteId, 'tabNum': this.tabNum, type: "comment", comment: this.comment, projectId: this.projectId, workSource: this.workSource } });
                }
                else if (this.courseLearningPathMetaId) {
                    this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId, 'constituteId': this.constituteId, 'tabNum': this.tabNum, type: "comment", comment: this.comment, courseLearningPathMetaId: this.courseLearningPathMetaId, workSource: this.workSource } });
                }
            }
            else {
                this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId, 'constituteId': this.constituteId, 'tabNum': this.tabNum, type: "comment", comment: this.comment, learningPathId: this.learningPathId, courseId: this.courseId } });
            }
        }
    };
    //点赞
    ComponentTool.prototype.giveAppreciate = function (data) {
        return this.apiService.ajax({
            'type': 'post',
            'url': '/ddilearner/v2/camp/applicationPractice/saveOperationLog',
            'data': data
        }).toPromise();
    };
    //点赞列表
    ComponentTool.prototype.getAppreciate = function () {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v2/camp/applicationPractice/getOperationLogList/3',
        }).toPromise();
    };
    return ComponentTool;
}());
export { ComponentTool };



// WEBPACK FOOTER //
// ./src/component/tool/component.tool.ts.pre-build-optimizer.js